import { map, filter } from 'lodash';
import { createSlice } from '@reduxjs/toolkit';
import { axiosInstance as axios } from '../../utils/axios';
import { dispatch } from '../store';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: false,
  data: [],
  meta: null,
  params: {
    page: 1,
    active: true,
    deleted: false,
  },
  record: null,
};

const slice = createSlice({
  name: 'hrVacationPolicy',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    getVacationPoliciesSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload.results;
      state.meta = action.payload.meta;
      state.error = false;
    },
    getVacationPolicySuccess(state, action) {
      state.isLoading = false;
      state.record = action.payload;
      state.error = false;
    },
    createVacationPolicySuccess(state, action) {
      state.isLoading = false;
      state.data = [...state.data, action.payload];
      state.error = false;
    },
    updateVacationPolicySuccess(state, action) {
      state.record = action.payload;
      state.isLoading = false;
      state.data = map(state.data, (_record) => (_record.id === action.payload.id ? action.payload : _record));
      state.params = { ...state.params };
      state.error = false;
    },
    deleteVacationPolicySuccess(state, action) {
      state.isLoading = false;
      state.data = filter(state.data, (r) => r.id !== action.payload.id);
      state.error = false;
    },
    setParams(state, action) {
      state.params = action.payload;
    },
    refreshParams(state) {
      state.params = { ...state.params };
    },
  },
});

export default slice.reducer;
export const { setParams, refreshParams } = slice.actions;

// ----------------------------------------------------------------------

export function getVacationPolicies(params = {}) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/hr/vacation-policy/', { params });
      dispatch(slice.actions.getVacationPoliciesSuccess(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      return error;
    }
  };
}

export function getVacationPolicy(id) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/hr/vacation-policy/${id}/`);
      dispatch(slice.actions.getVacationPolicySuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function createVacationPolicy(record) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/hr/vacation-policy/', record);
      dispatch(slice.actions.createVacationPolicySuccess(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

export function updateVacationPolicy(id, record) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.put(`/hr/vacation-policy/${id}/`, record);
      dispatch(slice.actions.updateVacationPolicySuccess(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

export function deleteVacationPolicy(id, restore = false) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      await axios.delete(`/hr/vacation-policy/${id}/`, { data: { restore } });
      dispatch(slice.actions.deleteVacationPolicySuccess({ id }));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

export function actionHistoryVacationPolicy(id, data) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post(`/hr/vacation-policy/${id}/history/`, data);
      dispatch(slice.actions.updateVacationPolicySuccess(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}
